const Logo = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="203.509"
      height="42"
      viewBox="0 0 203.509 42"
    >
      <g>
        <g>
          <path
            d="M483.118,262.2l-3.906-5.707a.344.344,0,0,1,0-.389l3.906-5.706a.344.344,0,0,1,.568,0l3.906,5.706a.344.344,0,0,1,0,.389l-3.906,5.707A.345.345,0,0,1,483.118,262.2Z"
            transform="translate(-462.402 -250.248)"
            fill="#00a26a"
          />
          <path
            d="M472.758,273.127l-5.706,3.906a.347.347,0,0,1-.389,0l-5.707-3.906a.345.345,0,0,1,0-.569l5.707-3.906a.347.347,0,0,1,.389,0l5.706,3.906A.345.345,0,0,1,472.758,273.127Z"
            transform="translate(-460.807 -251.843)"
            fill="#00a26a"
          />
          <path
            d="M475.783,265.57l-5.82-2.02a.614.614,0,0,1-.378-.378l-2.021-5.821c-.1-.291.055-.446.346-.345l5.82,2.02a.614.614,0,0,1,.378.378l2.021,5.821C476.23,265.516,476.075,265.671,475.783,265.57Z"
            transform="translate(-461.392 -250.833)"
            fill="#007b69"
          />
          <path
            d="M493.7,273.127l5.707,3.906a.346.346,0,0,0,.388,0l5.707-3.906a.345.345,0,0,0,0-.569l-5.707-3.906a.346.346,0,0,0-.388,0l-5.707,3.906A.345.345,0,0,0,493.7,273.127Z"
            transform="translate(-463.654 -251.843)"
            fill="#00a26a"
          />
          <path
            d="M491.009,265.57l5.82-2.02a.614.614,0,0,0,.378-.378l2.021-5.821c.1-.291-.055-.446-.346-.345l-5.82,2.02a.614.614,0,0,0-.378.378l-2.021,5.821C490.563,265.516,490.718,265.671,491.009,265.57Z"
            transform="translate(-463.4 -250.833)"
            fill="#007b69"
          />
          <path
            d="M483.118,283.144l-3.906,5.707a.344.344,0,0,0,0,.389l3.906,5.707a.345.345,0,0,0,.568,0l3.906-5.707a.344.344,0,0,0,0-.389l-3.906-5.707A.345.345,0,0,0,483.118,283.144Z"
            transform="translate(-462.402 -253.095)"
            fill="#00a26a"
          />
          <path
            d="M475.783,280.1l-5.82,2.02a.613.613,0,0,0-.378.379l-2.021,5.82c-.1.291.055.446.346.345l5.82-2.02a.614.614,0,0,0,.378-.378l2.021-5.821C476.23,280.158,476.075,280,475.783,280.1Z"
            transform="translate(-461.392 -252.841)"
            fill="#007b69"
          />
          <path
            d="M491.009,280.1l5.82,2.02a.613.613,0,0,1,.378.379l2.021,5.82c.1.291-.055.446-.346.345l-5.82-2.02a.614.614,0,0,1-.378-.378l-2.021-5.821C490.563,280.158,490.718,280,491.009,280.1Z"
            transform="translate(-463.4 -252.841)"
            fill="#007b69"
          />
        </g>
        <path
          d="M525.249,265.334l6.384,14.328a.1.1,0,0,1-.089.137h-2.917a.1.1,0,0,1-.089-.057l-1.115-2.5a.1.1,0,0,0-.09-.058H522a.1.1,0,0,0-.089.058l-1.095,2.5a.1.1,0,0,1-.089.058h-2.9a.1.1,0,0,1-.089-.137l6.3-14.328Zm.972,8.867-1.475-3.554a.1.1,0,0,0-.181,0l-1.474,3.554a.1.1,0,0,0,.089.135h2.951A.1.1,0,0,0,526.221,274.2Z"
          transform="translate(-465.756 -251.559)"
        />
        <path
          d="M587.529,265.334l6.384,14.328a.1.1,0,0,1-.089.137h-2.916a.1.1,0,0,1-.089-.057l-1.115-2.5a.1.1,0,0,0-.089-.058h-5.336a.1.1,0,0,0-.089.058l-1.095,2.5a.1.1,0,0,1-.089.058h-2.9a.1.1,0,0,1-.089-.137l6.3-14.328Zm.972,8.867-1.476-3.554a.1.1,0,0,0-.181,0L585.37,274.2a.1.1,0,0,0,.09.135h2.95A.1.1,0,0,0,588.5,274.2Z"
          transform="translate(-471.172 -251.559)"
        />
        <path
          d="M652.665,265.334l6.379,14.317a.105.105,0,0,1-.1.148h-2.9l-.1-.062-1.112-2.5a.1.1,0,0,0-.089-.058h-5.335a.1.1,0,0,0-.089.058l-1.093,2.5-.1.063h-2.88a.1.1,0,0,1-.1-.148l6.3-14.317Zm.972,8.867-1.475-3.554a.1.1,0,0,0-.181,0l-1.475,3.554a.1.1,0,0,0,.089.135h2.951A.1.1,0,0,0,653.638,274.2Z"
          transform="translate(-476.836 -251.559)"
        />
        <path
          d="M549.943,279.8h-8.418a.1.1,0,0,1-.1-.1v-14.27a.1.1,0,0,1,.1-.1h2.649a.1.1,0,0,1,.1.1v11.427a.1.1,0,0,0,.1.1h5.574a.1.1,0,0,1,.1.1V279.7A.1.1,0,0,1,549.943,279.8Z"
          transform="translate(-467.817 -251.559)"
        />
        <path
          d="M560.374,279.7v-14.27a.1.1,0,0,1,.1-.1h4.874a7.5,7.5,0,0,1,2.875.527,6.158,6.158,0,0,1,2.179,1.488,6.712,6.712,0,0,1,1.391,2.294,8.451,8.451,0,0,1,.491,2.945,8.041,8.041,0,0,1-.491,2.842,6.858,6.858,0,0,1-1.391,2.283,6.431,6.431,0,0,1-2.179,1.529,7.113,7.113,0,0,1-2.875.558h-4.874A.1.1,0,0,1,560.374,279.7Zm2.823-2.872a.1.1,0,0,0,.1.1h2.051a3.977,3.977,0,0,0,1.626-.331,3.935,3.935,0,0,0,1.3-.919,4.208,4.208,0,0,0,.86-1.384,4.891,4.891,0,0,0,0-3.41,4.217,4.217,0,0,0-.86-1.384,4.075,4.075,0,0,0-1.3-.93,3.867,3.867,0,0,0-1.626-.341h-2.051a.1.1,0,0,0-.1.1Z"
          transform="translate(-469.464 -251.559)"
        />
        <path
          d="M608.568,271.611h5.41a.1.1,0,0,1,.1.1v5.954a.105.105,0,0,1-.036.078,9.172,9.172,0,0,1-2.389,1.565,6.833,6.833,0,0,1-2.772.552,7.076,7.076,0,0,1-3.007-.625,7.337,7.337,0,0,1-2.3-1.637,7.151,7.151,0,0,1-1.463-2.322,7.351,7.351,0,0,1-.512-2.7,7.146,7.146,0,0,1,.625-3.018,7.322,7.322,0,0,1,6.659-4.307,7.049,7.049,0,0,1,2.824.594,7.981,7.981,0,0,1,2.424,1.648.1.1,0,0,1,0,.142l-1.875,1.974h0a6,6,0,0,0-1.625-1.115,4.162,4.162,0,0,0-1.75-.4,4.324,4.324,0,0,0-1.728.349,4.387,4.387,0,0,0-1.412.961,4.57,4.57,0,0,0-.951,1.432,4.4,4.4,0,0,0-.348,1.739,4.325,4.325,0,0,0,.348,1.728,4.45,4.45,0,0,0,2.363,2.364,4.324,4.324,0,0,0,1.728.348,4.5,4.5,0,0,0,1.227-.174,4.972,4.972,0,0,0,1.147-.482v-1.9h-2.684a.1.1,0,0,1-.1-.1v-2.649A.1.1,0,0,1,608.568,271.611Z"
          transform="translate(-473.048 -251.552)"
        />
        <path
          d="M637.225,279.8h-3.239a.1.1,0,0,1-.08-.041l-3.828-5.434a.1.1,0,0,0-.079-.042H628.33v5.42a.1.1,0,0,1-.1.1h-2.915a.1.1,0,0,1-.1-.1v-14.27a.1.1,0,0,1,.1-.1H631.3a4.173,4.173,0,0,1,1.7.351,4.505,4.505,0,0,1,1.4.961,4.734,4.734,0,0,1,.963,1.415,4.252,4.252,0,0,1,.357,1.737,4.426,4.426,0,0,1-.7,2.448,4.225,4.225,0,0,1-1.72,1.555.091.091,0,0,0-.037.136l4.042,5.708A.1.1,0,0,1,637.225,279.8Zm-6.46-8.369a2.247,2.247,0,0,0,1.6-.486,1.527,1.527,0,0,0,.511-1.147,1.467,1.467,0,0,0-.511-1.127,2.318,2.318,0,0,0-1.6-.465h-2.337a.1.1,0,0,0-.1.1v3.029a.1.1,0,0,0,.1.1Z"
          transform="translate(-475.103 -251.559)"
        />
        <path
          d="M674.594,276.51l-3.514-4.873a.1.1,0,0,0-.176.058v7.942a.163.163,0,0,1-.163.163h-2.584a.1.1,0,0,1-.1-.1V265.334h1.887a.1.1,0,0,1,.078.04l5.095,7.054a.1.1,0,0,0,.158,0l5.094-7.054a.1.1,0,0,1,.079-.04h1.812a.111.111,0,0,1,.074.1v14.2a.163.163,0,0,1-.163.163h-2.517a.164.164,0,0,1-.164-.163v-7.942a.1.1,0,0,0-.176-.058L675.8,276.51Z"
          transform="translate(-478.828 -251.559)"
        />
      </g>
    </svg>
  )
}

export default Logo
